import { Id } from 'src/types/common';
import { Profile } from 'src/types/user';
import { formatFullName } from 'src/utils/format';

export const SESSIONS_KEY = 'deinverband:devSessions';
export const AUTH_PROVIDER_KEY = 'deinverband:authProvider';

export interface Session {
  id: string;
  name: string;
  session: string;
}

export interface AuthContextType {
  signInWithEmailAndPassword?: (
    email: string,
    password: string
  ) => Promise<void>;
  signInWithToken?: (token: string) => Promise<void>;
  signInRedirect?: () => Promise<void>;
  signInCallback?: () => Promise<void>;
  signOut: (reason?: string) => Promise<void>;
  // user management
  updatePassword?: (current: string, password: string) => Promise<void>;
  resetPassword?: (email: string) => Promise<void>;
}

export const getSessions = (): Session[] => {
  const sessions = localStorage.getItem(SESSIONS_KEY);
  return sessions ? JSON.parse(sessions) : [];
};

export const getSession = (storageId: Id) => {
  const sessions = getSessions();
  const session = sessions.find((session) => session.id === storageId);
  if (!session) throw new Error('Session not found');

  return session;
};

export const setSession = (
  profile: Profile,
  session: string | null | undefined
) => {
  if (!session) throw new Error('Session not provided');
  const sessions = getSessions();

  // insert or update the session
  localStorage.setItem(
    SESSIONS_KEY,
    JSON.stringify([
      ...sessions.filter((session) => session.id !== profile.id),
      {
        id: profile.id,
        name: formatFullName(profile) || profile.email,
        session
      }
    ])
  );
};
